import React, { useEffect, useState } from 'react';
import { ArrowLeftIcon, LinkedinIcon, TwitterIcon, MailIcon, AwardIcon, BookOpenIcon, BriefcaseIcon, UserIcon, CheckCircleIcon, ScanLineIcon, UsersIcon, MessageSquareIcon, BarChart3Icon, HeartIcon, TrendingUpIcon } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
// Sample data for connections (same as in ConnectionsList)
const connectionsData = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'Data Scientist @ Intel',
  location: 'Milano, Italia',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 95,
  tags: ['AI', 'Machine Learning', 'ESG'],
  matchReason: 'Avete partecipato agli stessi 3 corsi e condividete interessi in AI e sostenibilità',
  connectionType: 'both',
  isConnected: true,
  bio: "Esperto di intelligenza artificiale con focus su soluzioni sostenibili. Sviluppo algoritmi di machine learning per ottimizzare l'efficienza energetica e ridurre l'impatto ambientale.",
  experience: [{
    title: 'Data Scientist',
    company: 'Intel',
    period: '2019 - Presente',
    description: 'Sviluppo di algoritmi di machine learning per progetti di sostenibilità e ottimizzazione energetica.'
  }, {
    title: 'ML Engineer',
    company: 'Deloitte Digital',
    period: '2016 - 2019',
    description: 'Implementazione di soluzioni di AI per clienti nel settore energetico e ambientale.'
  }],
  groups: ['AI for Sustainability', 'Green Tech Network', 'Data Science Italia'],
  courses: [{
    name: 'Innovazione Sostenibile per le Imprese',
    completed: true,
    date: 'Maggio 2023'
  }, {
    name: 'Economia Circolare',
    completed: true,
    date: 'Marzo 2023'
  }, {
    name: 'Energie Rinnovabili',
    completed: false,
    progress: 42
  }],
  certifications: [{
    name: 'ESG Data Analysis Expert',
    issuer: 'EIIS',
    date: 'Maggio 2023'
  }, {
    name: 'AI for Sustainability',
    issuer: 'EIIS',
    date: 'Marzo 2023'
  }]
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'ML Engineer @ Google',
  location: 'Roma, Italia',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 88,
  tags: ['Deep Learning', 'Computer Vision', 'Sostenibilità'],
  matchReason: 'Competenze complementari in Deep Learning e Computer Vision. Entrambi interessati a progetti di sostenibilità',
  connectionType: 'course',
  isConnected: true,
  bio: "Specialista in computer vision e deep learning applicati a progetti di sostenibilità ambientale. Sviluppo soluzioni innovative per il monitoraggio ambientale e l'ottimizzazione delle risorse.",
  experience: [{
    title: 'ML Engineer',
    company: 'Google',
    period: '2020 - Presente',
    description: 'Sviluppo di modelli di computer vision per progetti ambientali e di sostenibilità.'
  }, {
    title: 'AI Researcher',
    company: 'Università La Sapienza',
    period: '2017 - 2020',
    description: 'Ricerca su algoritmi di deep learning per il monitoraggio ambientale e la conservazione della biodiversità.'
  }],
  groups: ['Women in AI', 'Computer Vision Italia', 'Tech for Good'],
  courses: [{
    name: 'Innovazione Sostenibile per le Imprese',
    completed: true,
    date: 'Aprile 2023'
  }, {
    name: 'Economia Circolare',
    completed: false,
    progress: 65
  }],
  certifications: [{
    name: 'Deep Learning for Sustainability',
    issuer: 'EIIS',
    date: 'Aprile 2023'
  }]
}, {
  id: 3,
  name: 'Alessandro Verdi',
  role: 'Sustainability Manager @ Enel',
  location: 'Firenze, Italia',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 82,
  tags: ['ESG', 'Energia Rinnovabile', 'Reporting'],
  matchReason: 'Entrambi specializzati in strategie ESG e avete completato il corso di Innovazione Sostenibile',
  connectionType: 'both',
  isConnected: true,
  bio: 'Manager con esperienza decennale in sostenibilità aziendale e strategie ESG. Specializzato in energia rinnovabile e reporting di sostenibilità secondo standard internazionali.',
  experience: [{
    title: 'Sustainability Manager',
    company: 'Enel',
    period: '2018 - Presente',
    description: 'Gestione delle strategie di sostenibilità e coordinamento dei progetti ESG a livello globale.'
  }, {
    title: 'ESG Consultant',
    company: 'EY',
    period: '2015 - 2018',
    description: 'Consulenza per aziende su reporting non finanziario e strategie di sostenibilità.'
  }],
  groups: ['ESG Leaders Italia', 'Renewable Energy Hub', 'Sustainability Reporting Network'],
  courses: [{
    name: 'Innovazione Sostenibile per le Imprese',
    completed: true,
    date: 'Febbraio 2023'
  }, {
    name: 'Economia Circolare',
    completed: true,
    date: 'Novembre 2022'
  }, {
    name: 'Energie Rinnovabili',
    completed: true,
    date: 'Luglio 2022'
  }],
  certifications: [{
    name: 'ESG Management Expert',
    issuer: 'EIIS',
    date: 'Febbraio 2023'
  }, {
    name: 'Sustainability Reporting Specialist',
    issuer: 'EIIS',
    date: 'Novembre 2022'
  }]
}, {
  id: 4,
  name: 'Giulia Neri',
  role: 'Circular Economy Specialist @ Accenture',
  location: 'Milano, Italia',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 78,
  tags: ['Economia Circolare', 'Sostenibilità', 'Consulenza'],
  matchReason: 'Condividete interessi in economia circolare e strategie di sostenibilità aziendale',
  connectionType: 'connected',
  isConnected: true,
  bio: "Consulente specializzata in economia circolare e trasformazione sostenibile delle aziende. Aiuto le organizzazioni a ripensare i loro modelli di business in ottica di circolarità e riduzione dell'impatto ambientale.",
  experience: [{
    title: 'Circular Economy Specialist',
    company: 'Accenture',
    period: '2019 - Presente',
    description: "Consulenza strategica per l'implementazione di modelli di business circolari e sostenibili."
  }, {
    title: 'Sustainability Consultant',
    company: 'KPMG',
    period: '2016 - 2019',
    description: "Supporto alle aziende per l'integrazione della sostenibilità nelle operazioni e nei processi decisionali."
  }],
  groups: ['Circular Economy Hub', 'Women in Sustainability', 'Consulenti ESG Italia'],
  courses: [{
    name: 'Economia Circolare',
    completed: true,
    date: 'Gennaio 2023'
  }, {
    name: 'Innovazione Sostenibile per le Imprese',
    completed: true,
    date: 'Ottobre 2022'
  }],
  certifications: [{
    name: 'Circular Economy Specialist',
    issuer: 'EIIS',
    date: 'Gennaio 2023'
  }, {
    name: 'Sustainable Business Transformation',
    issuer: 'EIIS',
    date: 'Ottobre 2022'
  }]
}, {
  id: 5,
  name: 'Paolo Marini',
  role: 'Green Finance Advisor @ Intesa',
  location: 'Torino, Italia',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 75,
  tags: ['Green Finance', 'ESG', 'Investimenti Sostenibili'],
  matchReason: 'Competenze complementari in finanza sostenibile e reporting ESG',
  connectionType: 'course',
  isConnected: false,
  bio: "Esperto di finanza sostenibile e investimenti ESG. Mi occupo di sviluppare prodotti finanziari che integrano criteri ambientali, sociali e di governance per favorire la transizione verso un'economia più sostenibile.",
  experience: [{
    title: 'Green Finance Advisor',
    company: 'Intesa Sanpaolo',
    period: '2020 - Presente',
    description: 'Sviluppo e gestione di prodotti finanziari sostenibili e consulenza ESG per investitori istituzionali.'
  }, {
    title: 'ESG Analyst',
    company: 'UniCredit',
    period: '2017 - 2020',
    description: 'Analisi e valutazione di investimenti secondo criteri ESG e sviluppo di metodologie di screening.'
  }],
  groups: ['Sustainable Finance Italia', 'ESG Investors Network', 'Green Bonds Community'],
  courses: [{
    name: 'Finanza Sostenibile',
    completed: true,
    date: 'Marzo 2023'
  }, {
    name: 'Innovazione Sostenibile per le Imprese',
    completed: true,
    date: 'Dicembre 2022'
  }],
  certifications: [{
    name: 'Green Finance Expert',
    issuer: 'EIIS',
    date: 'Marzo 2023'
  }, {
    name: 'ESG Investment Analyst',
    issuer: 'EIIS',
    date: 'Dicembre 2022'
  }]
}, {
  id: 6,
  name: 'Chiara Esposito',
  role: 'Corporate Sustainability @ Eni',
  location: 'Roma, Italia',
  avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  matchPercentage: 71,
  tags: ['Corporate Sustainability', 'Carbon Management', 'ESG'],
  matchReason: 'Entrambi lavorano nel settore della sostenibilità aziendale con focus su carbon management',
  connectionType: 'course',
  isConnected: false,
  bio: 'Professionista della sostenibilità aziendale con focus su strategie di decarbonizzazione e carbon management. Lavoro per integrare obiettivi climatici ambiziosi nelle strategie di business delle grandi aziende.',
  experience: [{
    title: 'Corporate Sustainability Manager',
    company: 'Eni',
    period: '2019 - Presente',
    description: 'Sviluppo e implementazione della strategia di sostenibilità aziendale con focus su riduzione delle emissioni.'
  }, {
    title: 'Carbon Strategy Consultant',
    company: 'McKinsey',
    period: '2016 - 2019',
    description: 'Consulenza per aziende su strategie di decarbonizzazione e gestione dei rischi climatici.'
  }],
  groups: ['Carbon Management Italia', 'Corporate Sustainability Network', 'Climate Leaders'],
  courses: [{
    name: 'Carbon Management',
    completed: true,
    date: 'Aprile 2023'
  }, {
    name: 'Innovazione Sostenibile per le Imprese',
    completed: true,
    date: 'Gennaio 2023'
  }],
  certifications: [{
    name: 'Carbon Strategy Expert',
    issuer: 'EIIS',
    date: 'Aprile 2023'
  }, {
    name: 'Corporate Sustainability Specialist',
    issuer: 'EIIS',
    date: 'Gennaio 2023'
  }]
}];
// Default profile data (for when no ID is provided)
const defaultProfile = {
  id: 0,
  name: 'Edoardo Gatner',
  role: 'CEO',
  location: 'Milano, Italia',
  avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4hFhikAPJ46vhrcKePNA5J/IMG_0014.jpg',
  tags: ['ESG', 'Sostenibilità', 'Green Finance'],
  bio: "Esperto di leadership aziendale con focus sulla sostenibilità e sull'innovazione. La mia missione è guidare le imprese verso un futuro più sostenibile, implementando strategie ESG efficaci e promuovendo la trasformazione digitale.",
  experience: [{
    title: 'CEO',
    company: 'GreenFuture S.p.A.',
    period: '2018 - Presente',
    description: "Leadership di un'azienda innovativa nel settore della sostenibilità. Sviluppo di strategie ESG e implementazione di soluzioni per la transizione ecologica."
  }, {
    title: 'Direttore Sostenibilità',
    company: 'Eco Solutions',
    period: '2014 - 2018',
    description: "Gestione del dipartimento di sostenibilità e coordinamento di progetti di economia circolare. Implementazione di strategie di reporting ESG e miglioramento dell'impronta ecologica aziendale."
  }, {
    title: 'Consulente Strategico',
    company: 'Green Consulting Group',
    period: '2010 - 2014',
    description: "Consulenza per aziende su tematiche di sostenibilità e innovazione. Sviluppo di piani strategici per l'implementazione di pratiche sostenibili."
  }],
  groups: ['ESG Leaders Network', 'Circular Economy Hub', 'Sustainability Innovators'],
  courses: [{
    name: 'Innovazione Sostenibile per le Imprese',
    completed: true,
    date: 'Maggio 2023'
  }, {
    name: 'Economia Circolare',
    completed: true,
    date: 'Marzo 2023'
  }, {
    name: 'Energie Rinnovabili',
    completed: false,
    progress: 42
  }],
  certifications: [{
    name: 'ESG Management Expert',
    issuer: 'EIIS',
    date: 'Maggio 2023'
  }, {
    name: 'Circular Economy Specialist',
    issuer: 'EIIS',
    date: 'Marzo 2023'
  }],
  stats: {
    connections: '127',
    impact: '92%',
    efficacy: '87%'
  }
};
const PublicProfile = () => {
  const {
    userId
  } = useParams();
  const [profileData, setProfileData] = useState(defaultProfile);
  useEffect(() => {
    // If userId is provided, find the matching connection
    if (userId) {
      const connection = connectionsData.find(c => c.id === parseInt(userId));
      if (connection) {
        // Create a profile data object from the connection data
        setProfileData({
          id: connection.id,
          name: connection.name,
          role: connection.role.split('@')[0].trim(),
          company: connection.role.split('@')[1]?.trim() || '',
          location: connection.location,
          avatar: connection.avatar,
          tags: connection.tags,
          bio: connection.bio || '',
          experience: connection.experience || [],
          groups: connection.groups || [],
          courses: connection.courses || [],
          certifications: connection.certifications || [],
          stats: {
            connections: Math.floor(Math.random() * 100 + 50).toString(),
            impact: `${Math.floor(Math.random() * 15 + 80)}%`,
            efficacy: `${Math.floor(Math.random() * 20 + 75)}%`
          }
        });
      }
    }
  }, [userId]);
  return <div className="min-h-screen bg-gray-100" data-id="element-2029">
      {/* Hero section with black background */}
      <div className="bg-black text-white" data-id="element-2030">
        {/* Topbar */}
        <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-2031">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kYK3VqJh5ErppvW42Sa6wk/IMG_1178.png" alt="EIIS Logo" className="h-8 object-contain" data-id="element-2032" />
          <Link to="/" className="py-2 px-4 bg-custom-green text-black rounded-lg font-medium hover:bg-custom-green/90 transition-colors" data-id="element-2033">
            Inizia
          </Link>
        </div>
        {/* Profile Header with central image */}
        <div className="container mx-auto px-4 pb-16 pt-8" data-id="element-2034">
          <div className="flex flex-col items-center" data-id="element-2035">
            {/* Profile image */}
            <div className="w-32 h-32 rounded-full border-4 border-white overflow-hidden mb-6" data-id="element-2036">
              <img src={profileData.avatar} alt={profileData.name} className="w-full h-full object-cover" data-id="element-2037" />
            </div>
            {/* Profile info */}
            <h1 className="text-3xl font-bold mb-2 text-center text-white" data-id="element-2038">
              {profileData.name}
            </h1>
            <p className="text-xl text-gray-300 mb-4 text-center" data-id="element-2039">
              {profileData.role}
              {profileData.company ? ` | ${profileData.company}` : ''} |{' '}
              {profileData.location.split(',')[0]}
            </p>
            {/* Tags */}
            <div className="flex flex-wrap gap-2 justify-center mb-6" data-id="element-2040">
              {profileData.tags.map((tag, index) => <span key={index} className="px-3 py-1 bg-custom-green/20 text-custom-green rounded-full text-sm" data-id="element-2041">
                  {tag}
                </span>)}
            </div>
            {/* Social and QR section */}
            <div className="flex flex-col md:flex-row items-center gap-8 mt-4" data-id="element-2042">
              {/* QR Code */}
              <div className="flex flex-col items-center" data-id="element-2043">
                <div className="w-32 h-32 bg-white p-2 rounded-lg" data-id="element-2044">
                  <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://eiis.it/profile/${profileData.id}`} alt="QR Code per connessione" className="w-full h-full" data-id="element-2045" />
                </div>
                <p className="text-sm text-gray-400 mt-2 text-center" data-id="element-2046">
                  Scansiona per connetterti
                </p>
              </div>
              {/* Social links */}
              <div className="flex flex-col items-center" data-id="element-2047">
                <div className="flex gap-3 mb-2" data-id="element-2048">
                  <button className="p-2 bg-gray-800 rounded-full text-gray-200 hover:bg-gray-700" data-id="element-2049">
                    <LinkedinIcon size={20} data-id="element-2050" />
                  </button>
                  <button className="p-2 bg-gray-800 rounded-full text-gray-200 hover:bg-gray-700" data-id="element-2051">
                    <TwitterIcon size={20} data-id="element-2052" />
                  </button>
                  <button className="p-2 bg-gray-800 rounded-full text-gray-200 hover:bg-gray-700" data-id="element-2053">
                    <MailIcon size={20} data-id="element-2054" />
                  </button>
                </div>
                <button className="py-2 px-4 bg-custom-green text-white rounded-lg font-medium hover:bg-custom-green/90 transition-colors" data-id="element-2055">
                  Aggiungi alle Connessioni
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* KPI Stats Section - Immediately below hero */}
      <div className="bg-white border-b border-gray-200" data-id="element-2056">
        <div className="container mx-auto px-4 py-6" data-id="element-2057">
          <div className="max-w-6xl mx-auto grid grid-cols-3 divide-x divide-gray-200" data-id="element-2058">
            <KpiCard icon={<UsersIcon size={18} data-id="element-2060" />} value={profileData.stats.connections} label="Connessioni" trend="+12 questo mese" trendUp={true} data-id="element-2059" />
            <KpiCard icon={<HeartIcon size={18} data-id="element-2062" />} value={profileData.stats.impact} label="Indice di Impatto" trend="Top 5% nella community" trendUp={true} data-id="element-2061" />
            <KpiCard icon={<TrendingUpIcon size={18} data-id="element-2064" />} value={profileData.stats.efficacy} label="Efficacia Profilo" trend="+15% rispetto al benchmark" trendUp={true} data-id="element-2063" />
          </div>
        </div>
      </div>
      {/* Main Content */}
      <main className="container mx-auto px-4 py-8" data-id="element-2065">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2066">
          {/* Left Column - About & Experience */}
          <div className="md:col-span-2 space-y-6" data-id="element-2067">
            {/* About Section */}
            <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-2068">
              <div className="flex items-center mb-4" data-id="element-2069">
                <UserIcon className="text-custom-green mr-2" size={20} data-id="element-2070" />
                <h2 className="text-xl font-semibold text-gray-800" data-id="element-2071">
                  Chi sono
                </h2>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-2072">{profileData.bio}</p>
            </div>
            {/* Experience Section */}
            <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-2073">
              <div className="flex items-center mb-4" data-id="element-2074">
                <BriefcaseIcon className="text-custom-green mr-2" size={20} data-id="element-2075" />
                <h2 className="text-xl font-semibold text-gray-800" data-id="element-2076">
                  Esperienza professionale
                </h2>
              </div>
              <div className="space-y-4" data-id="element-2077">
                {profileData.experience.map((exp, index) => <div key={index} className={`border-l-2 ${index === 0 ? 'border-custom-green' : 'border-gray-200'} pl-4 ${index < profileData.experience.length - 1 ? 'pb-4' : ''}`} data-id="element-2078">
                    <h3 className="font-medium text-gray-800" data-id="element-2079">{exp.title}</h3>
                    <p className="text-gray-600 text-sm" data-id="element-2080">
                      {exp.company} • {exp.period}
                    </p>
                    <p className="text-gray-700 mt-2 text-sm" data-id="element-2081">
                      {exp.description}
                    </p>
                  </div>)}
              </div>
            </div>
            {/* Active Groups */}
            <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-2082">
              <div className="flex items-center mb-4" data-id="element-2083">
                <UsersIcon className="text-custom-green mr-2" size={20} data-id="element-2084" />
                <h2 className="text-xl font-semibold text-gray-800" data-id="element-2085">
                  Gruppi attivi
                </h2>
              </div>
              <div className="space-y-3" data-id="element-2086">
                {profileData.groups.map((group, index) => <GroupItem key={index} name={group} members={Math.floor(Math.random() * 30 + 20)} data-id="element-2087" />)}
              </div>
            </div>
          </div>
          {/* Right Column - EIIS Path & Certifications */}
          <div className="space-y-6" data-id="element-2088">
            {/* EIIS Path */}
            <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-2089">
              <div className="flex items-center mb-4" data-id="element-2090">
                <BookOpenIcon className="text-custom-green mr-2" size={20} data-id="element-2091" />
                <h2 className="text-xl font-semibold text-gray-800" data-id="element-2092">
                  Percorso EIIS
                </h2>
              </div>
              <div className="space-y-4" data-id="element-2093">
                {profileData.courses.map((course, index) => <div key={index} className="flex items-start" data-id="element-2094">
                    <div className="w-16 h-16 rounded-md overflow-hidden flex-shrink-0" data-id="element-2095">
                      <img src={course.name.includes('Innovazione') ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/91SHa3uVeGUZjphgY5kVCZ/IMG_0008.jpg' : course.name.includes('Economia') ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/e6q9bYZMJLFCPnNQNXpuTz/IMG_0010.jpg' : 'https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80'} alt={course.name} className="w-full h-full object-cover" data-id="element-2096" />
                    </div>
                    <div className="ml-3 flex-1" data-id="element-2097">
                      <div className="flex items-center" data-id="element-2098">
                        {course.completed ? <CheckCircleIcon size={16} className="text-custom-green mr-1" data-id="element-2099" /> : <div className="w-4 h-4 rounded-full border-2 border-gray-300 mr-1" data-id="element-2100"></div>}
                        <h3 className="font-medium text-gray-800 text-sm" data-id="element-2101">
                          {course.name}
                        </h3>
                      </div>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-2102">
                        {course.completed ? `Completato • ${course.date}` : `In corso • ${course.progress}% completato`}
                      </p>
                      {!course.completed && <div className="w-full bg-gray-200 rounded-full h-1.5 mt-2" data-id="element-2103">
                          <div className="bg-custom-green h-1.5 rounded-full" style={{
                      width: `${course.progress}%`
                    }} data-id="element-2104"></div>
                        </div>}
                    </div>
                  </div>)}
              </div>
            </div>
            {/* Certifications */}
            <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-2105">
              <div className="flex items-center mb-4" data-id="element-2106">
                <AwardIcon className="text-custom-green mr-2" size={20} data-id="element-2107" />
                <h2 className="text-xl font-semibold text-gray-800" data-id="element-2108">
                  Certificazioni
                </h2>
              </div>
              <div className="space-y-4" data-id="element-2109">
                {profileData.certifications.map((cert, index) => <div key={index} className="border border-gray-200 rounded-lg p-3" data-id="element-2110">
                    <div data-id="element-2111">
                      <h3 className="font-medium text-gray-800" data-id="element-2112">{cert.name}</h3>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-2113">
                        {cert.issuer} • Rilasciato {cert.date}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>
            {/* Connect with EIIS */}
            <div className="bg-custom-green rounded-xl shadow-sm p-6 text-white" data-id="element-2114">
              <h2 className="text-xl font-semibold mb-2" data-id="element-2115">
                Vuoi crescere come {profileData.name.split(' ')[0]}?
              </h2>
              <p className="text-sm mb-4 text-white/90" data-id="element-2116">
                Scopri i percorsi formativi EIIS e unisciti alla community di
                professionisti della sostenibilità.
              </p>
              <button className="w-full py-2 bg-white text-custom-green font-medium rounded-lg hover:bg-white/90 transition-colors" data-id="element-2117">
                Scopri EIIS
              </button>
            </div>
          </div>
        </div>
      </main>
      <footer className="bg-gray-100 py-6 mt-10" data-id="element-2118">
        <div className="container mx-auto px-4 text-center text-gray-600 text-sm" data-id="element-2119">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oFwFFUSVexni1PfSaiTmFx/IMG_0017.png" alt="EIIS Logo" className="h-12 w-auto object-contain mx-auto mb-3" data-id="element-2120" />
          <p data-id="element-2121">
            © 2023 EIIS - European Institute for Innovation and Sustainability
          </p>
          <p className="mt-1" data-id="element-2122">Tutti i diritti riservati</p>
        </div>
      </footer>
    </div>;
};
interface KpiCardProps {
  icon: React.ReactNode;
  value: string;
  label: string;
  trend: string;
  trendUp?: boolean;
}
const KpiCard: React.FC<KpiCardProps> = ({
  icon,
  value,
  label,
  trend,
  trendUp
}) => {
  return <div className="px-4 py-5 flex flex-col items-center text-center" data-id="element-2123">
      <div className="p-2 bg-gray-100 rounded-full text-custom-green mb-2" data-id="element-2124">
        {icon}
      </div>
      <div className="text-2xl font-semibold text-gray-800 mb-1" data-id="element-2125">{value}</div>
      <div className="text-sm text-gray-600" data-id="element-2126">{label}</div>
      <div className={`text-xs ${trendUp ? 'text-custom-green' : 'text-gray-500'} mt-1`} data-id="element-2127">
        {trend}
      </div>
    </div>;
};
interface GroupItemProps {
  name: string;
  members: number;
}
const GroupItem: React.FC<GroupItemProps> = ({
  name,
  members
}) => {
  return <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-2128">
      <div className="flex items-center" data-id="element-2129">
        <div className="w-8 h-8 rounded-full bg-custom-green/20 flex items-center justify-center text-custom-green mr-3" data-id="element-2130">
          <UsersIcon size={16} data-id="element-2131" />
        </div>
        <span className="font-medium text-gray-700" data-id="element-2132">{name}</span>
      </div>
      <span className="text-sm text-gray-500" data-id="element-2133">{members} membri</span>
    </div>;
};
export default PublicProfile;